
export const datetimeCoverter =(inputDate)=> {
   // const inputDate = "2025-06-17T12:49:25.951Z";
const date = new Date(inputDate);

// Extract parts
const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
const year = date.getFullYear();

const hours = String(date.getHours()).padStart(2, '0');
const minutes = String(date.getMinutes()).padStart(2, '0');

// Format
const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
return formatted;
//console.log(formatted); // Output: 17/06/2025 12:49
}

